'use strict';

define('modules/module.dealers',[
  'jquery',
  './module',
  'txt!./module.hbs',
  'txt!./module.loader.hbs',
  'txt!./module.dealers.header.hbs',
  'txt!./module.dealers.results.hbs',
  'txt!./module.dealers.action.hbs',
  'txt!./module.paginator.hbs',
  'txt!./module.paginator.pma.hbs',
  'zipTools',
  'lib/util/zip',
  'storageUtil',
  'lib/util/map.static',
  'lib/zipFromText',
  'lib/services/batws',
  'lib/paginator',
  'lib/transforms/dealer.tmpl.common',
  'cookies',
  'lib/util/tda.config',

  // Side Effect Includes
  'lib/validator'
], function (
  $,
  Module,
  txtTemplate,
  txtLoader,
  txtHeader,
  txtResults,
  txtAction,
  txtPagination,
  txtPaginationPma,
  zipTools,
  zip,
  storageUtil,
  mapStatic,
  zipFromText,
  batws,
  Paginator,
  xformDealersCommon,
  cookies,
  tdaConfig
) {
  var __tmplHeader = Handlebars.compile(txtHeader);
  var __tmplLoader = Handlebars.compile(txtLoader);
  var __tmplResults = Handlebars.compile(txtResults);
  var __tmplPagination = Handlebars.compile(txtPagination);
  var __tmplPaginationPma = Handlebars.compile(txtPaginationPma);
  var __tmplAction = Handlebars.compile(txtAction);

  var __identityFilter = function () {
    return true;
  };
  var __pmaFilter = function (dealer) {
    return dealer.isPma;
  };
  var DealersModule = Module.extend({
    template: Handlebars.compile(txtTemplate),
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .js-geolocate-mod': 'onLocateClicked',
        'keydown .js-geolocate-mod': 'onLocateKeyDown', // BAT-4401 ADA.
        'submit .js-search-form': 'onSearchSubmit',
        'click .js-search-submit': 'onSearchClick',
        'keydown .js-search-submit': 'onSearchKeyDown', // BAT-4401 ADA.
        'click .js-search-restart': 'showFront', // zip link in top right
        'click .copy-cta': 'backToResults', // Dealer list link, top left in dealer details
        'click .module-page-next': 'nextPage',
        'click .module-page-prev': 'prevPage',
        'click .module-page-all': 'onViewAllClicked', // module.paginator.pma.hbs
        'click .dealer-detail-view': 'onDealerDetailClicked',
        'keydown .dealer-detail-view': 'onDealerDetailKeyDown', // BAT-4401 ADA.
        'click .detail-cta-info': 'onViewMoreInfo', // module.fad.rsults.hbs 'More Info' CTAs*/
        'keydown .js-search-form': 'onSubmitKeyDown' // BAT-4448
      });
    },

    initialize: function () {
      Module.prototype.initialize.apply(this, arguments);
      this.filter = __identityFilter;
    },

    onrender: function () {
      var self = this;
      this.$front = this.$el.children('.module-front');
      this.$form = this.$front.find('form');
      this.$back = this.$el.children('.module-back');
      this.$frontInput = this.$front.find('input');
      this.$backSideHeader = this.$back.find('.module-header');
      this.$backSideContent = this.$back.find('.module-content');
      this.$backSideFooter = this.$back.find('.module-footer');

      // update FAD input if confirmed zip
      if (storageUtil.isConfirmedZip()) {
        this.$frontInput.val(zip.getCookiedDefaultFallback());
      }

      $(window).on('ZIP_CODE_CHANGED', function () {
        self.$frontInput.val(zip.getCookiedDefaultFallback());
      });

      self.$form.validate({
        errorClass: 'mod-footer-ui-state-error',
        highlight: function (element, errorClass, validClass) {
          $(element).closest('.module-footer').addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).closest('.module-footer').removeClass(errorClass);
        },
        onsubmit: true
      });
      this.updateModuleDataLayer();
      this.localRender(); // specific to FAD Module, if need be
    },

    localRender: function () {}, // intentional no-op

    // BAT-4401 ADA
    onLocateKeyDown: function (e) {
      if (e.keyCode === 13) {
        // self.onLocateClicked(e);
        // BAT-4448 need to emulate element click to fire analytics.
        $('.js-geolocate-mod').each(function () {
          var hasFocus = $($(this)).is(':focus');
          if (hasFocus) {
            $($(this)).trigger('click');
          }
        });
      }
    },
    onLocateClicked: function (e) {
      e.preventDefault();
      var self = this;
      var success = function (newZip) {
        self.$frontInput.val(newZip);
      };
      zipTools.geoLocationZip.detect(success, zipTools.reLoadDealerSearchWithoutZip);
    },

    onSearchSubmit: function (e) {
      e && e.preventDefault();
      var self = this;
      this.searchTerm = this.$frontInput.val();
      var newZip = this.searchTerm;
      this.updateModuleDataLayer();

      if (self.$form.valid()) {
        self.$frontInput.blur();
        // PMA Search
        if (newZip && $.isNumeric(newZip) && zip.isZipFormatValid(newZip)) {
          self.searchZip = newZip;
          self.showBack();
          self.setMode('pma');
          self.beginSearch(newZip);
          self.dealer_search_type = 'zip';

        // text search
        } else if (newZip) {
          self.showBack();
          self.dealer_search_type = 'text';
          zipFromText(newZip)
            .then(function (res) {
              self.searchZip = res; // response is the computed zip
              self.beginSearch(res);
            })
            .catch(function (res) {
              console.error('zipFromText fail: ', res); // eslint-disable-line no-console
              self.showFront();
            });
        }
      }
    },

    // BAT-4448 - trigger analytics when using Enter button for search
    onSubmitKeyDown: function (e) {
      if (e.keyCode === 13) {
        $("input[name='dealer-search']").each(function () {
          var hasFocus = $($(this)).is(':focus');
          // console.log(hasFocus);
          if (hasFocus) {
            // var closestSubmit = $(this).closest('div').find('.js-search-submit');
            // console.log(closestSubmit);
            $($(this)).closest('div').find('.js-search-submit').trigger('click');
          }
        });
      }
    },

    // there's a default dataLayer output on parent .module
    // take that and supplement it with our results.
    updateModuleDataLayer: function () {
      var resultCount = this.data ? this.data.records.length.toString() : '0';
      var dataToAdd = {
        dealer_search_term: this.searchTerm || '',
        dealer_search_results_count: resultCount,
        dealer_search_brand: 'Toyota',
        dealer_search_type: this.dealer_search_type || '',
      };

      var $parent = this.$el;
      var data = $parent.data('layer') || {};
      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }
      // update data on parent module
      var fullData = Object.assign({}, data, dataToAdd);
      $parent.data('layer', fullData);
      // BAT-4461 - merge the updated data into dataLayerBAT
      if (window.dataLayerBAT) {
        $.extend(window.dataLayerBAT.data, fullData);
      }
    },

    // BAT-4401 ADA
    onSearchKeyDown: function (event) {
      if (event.keyCode === 13) {
        // BAT-4448 need to emulate element click to fire analytics.
        $('.js-search-submit').each(function () {
          var hasFocus = $($(this)).is(':focus');
          if (hasFocus) {
            $($(this)).trigger('click');
          }
        });
      }
    },

    onSearchClick: function () {
      this.onSearchSubmit();
    },

    setMode: function (mode) {
      this.mode = mode;
      if (mode === 'pma') {
        this.filter = __pmaFilter;
      } else {
        this.filter = __identityFilter;
      }
    },

    onViewAllClicked: function (e) {
      e && e.preventDefault();
      this.setMode('all');
      this.showPage(this.paginator.pageData);
      var loadData = {
        link_text: 'View More Dealers'
      };
      $.extend(window.dataLayerBAT.data, loadData);
      window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
    },

    showLoader: function () {
      this.$backSideContent.html(__tmplLoader());
    },

    showFront: function (e) {
      e && e.preventDefault();
      this.$back.hide().removeClass('is-visible');
      this.$front.show().toggleClass('is-visible').attr('style', '');
    },

    showBack: function (e) {
      e && e.preventDefault();
      this.$front.hide().removeClass('is-visible');
      this.$back.show().addClass('is-visible').attr('style', ''); // remove jQuery's inline block
      this.$backSideHeader.removeClass('header-slp-success'); // this class MAY bre present :(
      this.showLoader();
    },

    backToResults: function (e) {
      e && e.preventDefault();
      this.showPage(this.paginator.pageData);
    },

    beginSearch: function (zip) {
      var self = this;
      var paginatorOpts = {
        query: {
          zipcode: zip
        },
        dataField: 'dealerLocator',
        countField: 'dealerCount',
        xform: xformDealersCommon,
        pageSize: 5
      };

      self.paginator = new Paginator(batws.geo().search, paginatorOpts);
      self.paginator.next()
        .then(function (data) {
          self.showPage(data);
        })
        .catch(function (err) { console.error('paginator next error: ', err); }); // eslint-disable-line no-console
    },

    // Takes in the pageStructure and blindly renders the page
    showPage: function (data) {
      var header = {
        en: {
          title: 'Select A Dealer',
          titleMore: 'Search:',
          searchTerm: this.searchTerm
        },
        es: {
          title: 'Elige un concesionario',
          titleMore: 'Buscar:',
          searchTerm: this.searchTerm,
        }
      };

      var actionsFooter = {
        en: {
          title: 'View More Dealers',
          url: '#'
        },
        es: {
          title: 'Ver más concesionarios',
          url: '#'
        }
      };

      // filter our data (based on mode). Mode is determined out of band
      // TIM: I've dirtied this with this.mode, and tied module.paginator.hbs to FAD
      data = $.extend({}, data, {
        records: data.records.filter(this.filter)
      });
      this.data = data;

      var dataCopy = {
        en: {
          miles: 'miles',
          next: 'Next',
          prev: 'Previous',
          of: 'of',
          noDealersTitle: 'No Dealers Found',
          noDealersCopy: 'Please <a href="#" class="js-search-restart">search again</a> using a different location.'
        },
        es: {
          miles: 'millas',
          next: 'Siguiente',
          prev: 'Anterior',
          of: 'de',
          noDealersTitle: 'No encontramos concesionarios',
          noDealersCopy: 'Por favor <a href="#" class="js-search-restart">busca nuevamente</a> con otra dirección.'
        }
      };
      // show Header, loader & footer
      this.$backSideHeader.html(__tmplHeader(header[this.getCanvas().getLang()]));
      this.$backSideContent.html(__tmplResults({
        result: this.data,
        resultCopy: dataCopy[this.getCanvas().getLang()]
      }));
      if (this.mode === 'pma') {
        // only render footer if we have results
        if (this.data.count !== 0) {
          this.$backSideFooter.html(__tmplPaginationPma({ action: actionsFooter[this.getCanvas().getLang()] }));
        } else {
          this.$backSideFooter.empty();
        }
      } else {
        this.$backSideFooter.html(__tmplPagination({
          page: this.data,
          resultCopy: dataCopy[this.getCanvas().getLang()]
        }));
      }
      this.updateModuleDataLayer();
    },

    nextPage: function (e) {
      e && e.preventDefault();
      var self = this;
      // are we already waiting for a .next to respond?
      if (self.paginator.hasNext()) {
        self.showLoader();
        self.paginator.next()
          .then(function (data) {
            self.showPage(data);
          })
          .catch(function (err) {
            var err = err;
            console.log('paginator next error: ', err);
          });
      }
    },

    prevPage: function (e) {
      e && e.preventDefault();
      var self = this;
      if (self.paginator.hasPrev()) {
        self.showLoader();
        var data = self.paginator.prev();
        self.showPage(data);
      }
    },

    onDealerDetailKeyDown: function (e) { // BAT-4401 ADA
      var self = this;
      if (e.keyCode === 13) {
        // self.onDealerDetailClicked(e);
        // BAT-4448 need to emulate element click to fire analytics.
        $('.dealer-detail-view').each(function () {
          var hasFocus = $($(this)).is(':focus');
          if (hasFocus) {
            $($(this)).trigger('click');
          }
        });
      }
    },

    onDealerDetailClicked: function (e) {
      var $target = $(e.currentTarget);
      var currDealer = $target.attr('data-dealercode'); // need this so its a string!
      this.getDealerDetail(currDealer);
    },

    getDealerDetail: function (currDealer) {
      // find current dealer in pagination.current arr
      var currDealerData = this.paginator._data.filter(function (obj) {
        return obj.dealerCode === currDealer;
      });

      this.drawDefaults(currDealerData[0]);
      // drawDealerDetailPage is the function to overwrite in each each module
      // this.drawDealerDetailPage(currDealerData[0]);
    },

    // All dealer details templates start out with these defaults
    // if additional content is needed (ie: CTAs) see module.fad.js addDetailContent()
    detailsDefaults: function (currDealerData) {
      return {
        en: {
          actions: [
            {
              title: 'More Information',
              url: '/' + tdaConfig.site.context_url + '/dealer-detail/?dealercode=' + currDealerData.dealerCode,
              key: 'info', // click event attached to this!
              tdaCode: currDealerData.tdaCode // TODO: get this from legit obj?
            }
          ],
          copy: {
            miles: 'miles away',
            phone: 'Phone',
            hours: 'Today\'s Hours'
          }
        },

        es: {
          actions: [
            {
              title: 'Más infó.',
              url: '/' + tdaConfig.site.context_url + '/dealer-detail/?dealercode=' + currDealerData.dealerCode,
              key: 'info',
              tdaCode: currDealerData.tdaCode // TODO: get this from legit obj?
            }
          ],
          copy: {
            miles: 'Millas de distancia',
            phone: 'Teléfono',
            hours: 'Horario de hoy'
          }
        }
      };
    },

    drawDefaults: function (currDealerData) {
      var self = this;
      // all dealerModules need to show loader and 'dump' the actions tpl
      this.showLoader();
      this.$backSideFooter.html(__tmplAction());
      this.details = this.detailsDefaults(currDealerData); // update the details obj
      // now dawLocal, each module should have this function
      this.drawLocal(currDealerData);
    },

    drawDetailHeader: function (headerObj) {
      this.$backSideHeader.html(__tmplHeader(headerObj[this.getCanvas().getLang()]));
    },

    // optional, invoke from within individual modules (if needed)
    drawMap: function (currDealerData) {
      var self = this;
      var dimensionMap = {
        '1': '218x235',
        '2': '218x235',
        '3': '426x235',
        'full': '460x295'
      };
      var moduleWidth = this.getConfig().width;

      var mapOptions = {
        location: currDealerData.coords.lat + ',' + currDealerData.coords.lon,
        zoom: 16,
        size: dimensionMap[moduleWidth],
        markers: true
      };

      mapStatic(mapOptions).done(function (res) {
        self.$backSideContent.find('div[data-dealercode="' + currDealerData.dealerCode + '"]').css({
          backgroundImage: "url('" + res + "')"
        });
      });
    },

    // view info links on dealer details pages
    onViewMoreInfo: function (e) {
      // get .data('tdaCode') does it match current TDA code? if so, just return anchor, else, use /goto/link
      var self = this;
      var $target = $(e.currentTarget);
      var linkTda = $target.data('tdacode');
      var currTda = storageUtil.getTDA();
      if (linkTda !== currTda) {
        e && e.preventDefault();
        zipTools.showConfirmZipChangeModal(self.searchZip, false, function () {
          cookies.setItem('transferZip', self.searchZip, new Date(Date.now() + zipTools.transferZipCookieTTL), '/', zipTools.getCrossDomainCookieDomain());
          window.location.href = '/GOTO/' + linkTda + $target.attr('href');
        });
      }
    }

  });

  return DealersModule;
});

